import Profile from '../../app/features/profile';
const ProfilePage = () => {
  return (
    <>
      <Profile />
    </>
  )
}

export default ProfilePage